export enum JobProgressStatus {
    Created = 'CREATED',
    Runnning = 'RUNNING',
    Failed = 'FAILED',
    Finished = 'FINISHED',
    Failure = 'FAILURE'
}
